import clsApiPost from '@cls/clsApiPost'

class clsWorkorderApi extends clsApiPost {

    loadStats() {
        return this.get(`stats`); 
    }
    async loadEmployees(date) {
        return this.post(`loademployees`, {date: date}); 
    }
    async loadUnassignedWorkorders(year, week, filter) {
        return this.post(`loadunassignedworkorders`, {year: year, week: week, filter: filter}); 
    }
    async loadWeekPlanning(year, week) {
        return this.post(`loadweekplanning`, {year: year, week: week}); 
    }
    
    async getPdf(id) {
        return this.getRaw(`downloadpdf/{id}`, {id: id}, {hideErrors: true});  
    }


    createAppointment(model) {
        return this.post(`appointment/create`, model); 
    }
    loadAppointment(id) {
        return this.post(`appointment/load`, {id: id}); 
    }
    saveAppointment(model) {
        return this.post(`appointment/save`, model); 
    }
    saveAppointmentNote(id_workorder, id_appointment, note) {
        return this.post(`appointment/savenote`, {id_workorder: id_workorder, id: id_appointment, note: note}); 
    }

    /**
     * remove one or more appointments
     */
    removeAppointments(id_workorder, ids) {
        return this.post(`appointment/remove`, {id_workorder: id_workorder, ids: ids}); 
    }
    /**
     * unlock one or more appointments
     */
    unlockAppointments(id_workorder, ids) {
        return this.post(`appointment/unlock`, {id_workorder: id_workorder, ids: ids}); 
    }

    /**
     * save an Appointment
     * This can be either a new appointment or a move.
     */
    saveAppointment(model) {
        return this.post(`appointment/save`, model); 
    }

    uploadWorkorderAttachment(formData) {
        return this.upload(formData, 'attachments/upload');
    }

    /**
     * remove one or more attachments - either workorder- or appointment related.
     */
    removeAttachments(id_workorder, ids) {
        return this.post(`attachments/remove`, {id_workorder: id_workorder, ids: ids}); 
    }

    /**
     * change the public flag of an attachment
     */
    setAttachmentVisibleInApp(id_workorder, id, bPublic) {
        return this.post(`attachments/setvisibleinapp`, {id_workorder: id_workorder, id: id, public: bPublic}); 
    }
    
    /**
     * rename an attachment
     */
    renameAttachment(id_workorder, id, name) {
        return this.post(`attachments/rename`, {id_workorder: id_workorder, id: id, name: name}); 
    }

    toStatusPlanned(id_workorders) {
        return this.post(`status/planned`, {ids: id_workorders}); 
    }
    toStatusExecuting(id_workorders) {
        return this.post(`status/executing`, {ids: id_workorders}); 
    }
    toStatusExecuted(id_workorders) {
        return this.post(`status/executed`, {ids: id_workorders}); 
    }
    toStatusFinished(id_workorders) {
        return this.post(`status/finished`, {ids: id_workorders}); 
    }
    toStatusCanceled(id_workorders) {
        return this.post(`status/canceled`, {ids: id_workorders}); 
    }

    workorderPdf(id) {
        return this.postRaw(`pdf`, {id: id}, {hideErrors: true});  
    }
    appointmentPdf(id) {
        return this.postRaw(`appointment/pdf`, {id: id}, {hideErrors: true});  
    }

    sendEmail(model) { 
        return this.post(`send`, model); 
    }
    loadSendData(id_workorder) { 
        return this.post(`loadsenddata`, {id: id_workorder}); 
    }

}

export default clsWorkorderApi;
